"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FileBlock = require("./FileBlock");
Object.keys(_FileBlock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FileBlock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FileBlock[key];
    }
  });
});